export default __webpack_public_path__ + "static/media/close.0073bc87.svg";